var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBkgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1285.4 581.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_8);\n        mix-blend-mode: multiply;\n        opacity: .32;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_8",
    "data-name": "Sfumatura senza nome 8",
    x1: -4152.59,
    y1: 1702.77,
    x2: -4152.59,
    y2: 1091.82,
    gradientTransform: "translate(4795.29 -1103.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a14392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "rgba(185, 50, 135, .64)",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "rgba(208, 34, 126, .29)",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "rgba(223, 24, 120, .08)",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e51576",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modalit\\xE0_Isolamento",
    "data-name": "Modalit\\xE0 Isolamento"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1285.4,
    height: 581.98,
    transform: "translate(1285.4 581.98) rotate(180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgUp);
export default __webpack_public_path__ + "static/media/bkg-up.d2ab1fa68bb1e8fffd4197885454cc91.svg";
export { ForwardRef as ReactComponent };